import { render, staticRenderFns } from "./ArticleRevisionsModal.vue?vue&type=template&id=fcd16c7e&"
import script from "./ArticleRevisionsModal.vue?vue&type=script&lang=js&"
export * from "./ArticleRevisionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRevisionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports